module.exports = __webpack_public_path__ + "img/store.d1f10f67.svg";